const MemoryImageCache = {
    add: (id, data) => images.set(id, data),
    get: id => images.get(id),
    remove: id => images.delete(id),
    has: id => images.has(id),
};

const images = new Map();

Object.freeze(MemoryImageCache);
export default MemoryImageCache;
